import React from 'react'
import PropTypes from 'prop-types'
import Illustration from 'assets/image/flow-manuva.png'

const Mission = () => {
  return (
    <section id="mission" className="">
      <div
        className={`
        flex flex-col justify-between py-10 px-6 m-auto left-0 right-0 max-w-[1024px] gap-y-10
        sm:flex-row
        lg:py-[80px] lg:px-14  
        xl:pt-[154px] xl:pb-[191px] xl:px-[120px] xl:max-w-[1440px]
      `}
      >
        <div className="lg:max-w-[440px] xl:max-w-[584px] relative">
          <Pattern
            className={`w-12 h-12 absolute right-0 top-0
          lg:w-16 lg:h-16 lg:right-[40px] lg:top-[-24px]
          xl:w-[104px] xl:h-[104px] xl:right-[20px] xl:top-[-50px]
          `}
          />

          <div className="bg-[#F8FAFB] py-3 px-5 w-fit">
            <h1 className="font-bold text-xs lg:text-sm text-[#003DA6] leading-[150%]">
              MANUVA
            </h1>
          </div>

          <div className="mt-6">
            <h1 className="h4-bold xl:h3-bold text-[#101838]">
              {'Increasing SME Manufacturer\'s Capacity and Utilization'}
            </h1>
            <p className="mt-4 lg:mt-6 text-m-reguler xl:text-l-reguler text-[#969FB6] xl:w-[502px]">
              We help produce and distribute the best ready-made and custom-made
              products directly from our manufacturers to retailers and B2B
              customers.
            </p>
          </div>
        </div>

        <div className="lg:mt-[87px] lg:max-w-[385px] xl:mt-[104px] xl:max-w-[513px]">
          <img src={Illustration} alt="" />
        </div>
      </div>
    </section>
  )
}

const Pattern = ({ className }) => {
  return (
    <svg className={className} width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" fill="#003DA6"/>
      <rect x="64" y="64" width="40" height="40" fill="#DEE9FF"/>
    </svg>
  )
}

Pattern.propTypes = {
  className: PropTypes.string
}

export default Mission
